<template>
  <BaseIcon2
    :class="className"
    :height="size === 'auto' ? '100%' : size"
    :width="size === 'auto' ? '100%' : size"
    class="c-loader"
    viewBox="0 0 100 100"
  >
    <g transform="translate(50 50)">
      <g transform="rotate(0) translate(34 0)">
        <circle
          cx="0"
          cy="0"
          r="2"
        />
      </g>

      <g transform="rotate(45) translate(34 0)">
        <circle
          cx="0"
          cy="0"
          r="2"
        />
      </g>

      <g transform="rotate(90) translate(34 0)">
        <circle
          cx="0"
          cy="0"
          r="2"
        />
      </g>

      <g transform="rotate(135) translate(34 0)">
        <circle
          cx="0"
          cy="0"
          r="2"
        />
      </g>

      <g transform="rotate(180) translate(34 0)">
        <circle
          cx="0"
          cy="0"
          r="2"
        />
      </g>

      <g transform="rotate(225) translate(34 0)">
        <circle
          cx="0"
          cy="0"
          r="2"
        />
      </g>

      <g transform="rotate(270) translate(34 0)">
        <circle
          cx="0"
          cy="0"
          r="2"
        />
      </g>

      <g transform="rotate(315) translate(34 0)">
        <circle
          cx="0"
          cy="0"
          r="2"
        />
      </g>
    </g>
  </BaseIcon2>
</template>

<script lang="ts" setup>
import type { SVGAttributes } from "vue";

interface Props extends /* @vue-ignore */ SVGAttributes {
  class?: string;
  color?: string;
  size?: number | "auto";
}

const props = withDefaults(defineProps<Props>(), {
  size: "auto",
});
const { class: className } = toRefs(props);
</script>

<style scoped>
@keyframes spin {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(4);
  }

  100% {
    transform: scale(1);
  }
}

circle {
  animation: spin 1s infinite;
}

g:nth-child(1) circle {
  animation-delay: 0s;
}

g:nth-child(2) circle {
  animation-delay: calc(1 / 8 * 1s);
}

g:nth-child(3) circle {
  animation-delay: calc(2 / 8 * 1s);
}

g:nth-child(4) circle {
  animation-delay: calc(3 / 8 * 1s);
}

g:nth-child(5) circle {
  animation-delay: calc(4 / 8 * 1s);
}

g:nth-child(6) circle {
  animation-delay: calc(5 / 8 * 1s);
}

g:nth-child(7) circle {
  animation-delay: calc(6 / 8 * 1s);
}

g:nth-child(8) circle {
  animation-delay: calc(7 / 8 * 1s);
}
</style>
